<template>
  <div v-if="visible" class="RiskMannBannerSoporte shadow d-flex align-items-center gap-2" role="status">
    <i class="fas fa-headset"></i>
    <span class="texto"><strong>Sesión de soporte</strong> en la cuenta de {{ correo }}</span>
    <button type="button" class="btn btn-sm btn-light fw-bold py-0 px-2" @click="salir()">Salir</button>
  </div>
</template>

<script>
import { auth } from "@/firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { DURACION_MAXIMA_SOPORTE_MS, desmarcarSesionSoporte, esSesionSoporte } from "@/utils/sesionSoporte";

/**
 * Franja visible mientras alguien de Soporte Técnico está en la cuenta de un usuario (ver
 * src/utils/sesionSoporte.js). Recuerda en qué cuenta está, permite salir y cierra la sesión sola
 * pasadas dos horas. Si la marca de la pestaña no viene con el permiso del panel en el token, la
 * descarta.
 */
export default {
  name: "RiskMannBannerSoporte",

  data() {
    return {
      visible: false,
      correo: "",
    };
  },

  mounted() {
    if (!esSesionSoporte()) return;
    this.dejarDeEscuchar = onAuthStateChanged(auth, this.revisar);
  },

  beforeDestroy() {
    if (this.dejarDeEscuchar) this.dejarDeEscuchar();
    clearTimeout(this.vencimiento);
  },

  methods: {
    async revisar(usuario) {
      clearTimeout(this.vencimiento);
      if (!usuario) {
        this.visible = false;
        return;
      }
      let resultado = null;
      try {
        resultado = await usuario.getIdTokenResult();
      } catch (error) {
        console.warn("No se pudo leer el token de la sesión de soporte:", error);
      }
      if (!resultado || !resultado.claims.soporte) {
        desmarcarSesionSoporte();
        this.visible = false;
        return;
      }
      this.correo = usuario.email || "";
      this.visible = true;
      const restante = Date.parse(resultado.authTime) + DURACION_MAXIMA_SOPORTE_MS - Date.now();
      this.vencimiento = setTimeout(this.salir, Math.max(restante, 0));
    },

    async salir() {
      desmarcarSesionSoporte();
      try {
        await signOut(auth);
      } catch (error) {
        console.error("No se pudo cerrar la sesión de soporte:", error);
      }
      // La abrió el panel administrativo: se cierra. Si el navegador no lo permite, va a la entrada.
      window.close();
      window.location.assign("/entrada");
    },
  },
};
</script>

<style scoped>
/* Abajo a la izquierda: la esquina derecha es del asistente y de la flecha de subir. Por encima de
   cualquier capa (modales, alertas y la de las guías, que usa 9997): siempre se puede salir. */
.RiskMannBannerSoporte {
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: 10000;
  max-width: calc(100% - 112px);
  padding: 8px 12px;
  border-radius: 999px;
  background: #b42318;
  color: #ffffff;
  font-size: 0.875rem;
}

.texto {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
